import { render, staticRenderFns } from "./PageMarginTop.vue?vue&type=template&id=1e8ca93a&scoped=true"
import script from "./PageMarginTop.vue?vue&type=script&lang=js"
export * from "./PageMarginTop.vue?vue&type=script&lang=js"
import style0 from "./PageMarginTop.vue?vue&type=style&index=0&id=1e8ca93a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8ca93a",
  null
  
)

export default component.exports